import React, { useCallback, useState } from 'react';
import { Modal, ModalVariant } from '@patternfly/react-core';

import { confirmButtons } from '../../../Modals/ModalButtons';
import { useTranslation } from '../../../../localization/useTranslation';
import SimpleTable, { RowSelection } from '../../../Common/SimpleTable/SimpleTable';

const ListSelectModal = ({ title, icon, isOpen, columns, data, onConfirm, confirmText, onCancel, cancelText }) => {
  const T = useTranslation();
  const [items, setSelectedItems] = useState([]);

  const _onConfirm = useCallback(() => {
    setSelectedItems([]);
    onConfirm(items);
  }, [items, onConfirm]);

  return (
    <Modal
      variant={ModalVariant.small}
      title={title}
      titleIconVariant={icon}
      isOpen={isOpen}
      onClose={onCancel}
      actions={confirmButtons({ T, onConfirm: _onConfirm, confirmText: confirmText, cancelText: cancelText, onCancel: onCancel })}
    >
      <SimpleTable
        data={data}
        columns={columns}
        compact
        onSelectedRows={setSelectedItems}
        rowSelection={RowSelection.SINGLE}
        RowSelection={() => {}}
        selectedRows={items}
        initialSelectedRows={[]}
      />

    </Modal>
  );
};

export default React.memo(ListSelectModal);
